import Toggle from "~/common/components/Toggle/Toggle";
import { selectIsRelevantFilterActive } from "~/Search/redux/searchSelectors";
import { updateRelevantFilterThunk } from "~/Search/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { InfoCircle } from "~/FreeCapacityPush/components/InfoCircle/InfoCircle";
import { ICON_MARGIN } from "~/styles/cssConstants";
import { styled } from "@mui/material";

interface Props {
  className?: string;
}

export const RelevantFilter = (props: Props) => {
  const { t } = useTranslation();

  const isActive = useSelector(selectIsRelevantFilterActive);
  const dispatch = useDispatch();
  const toggle = () => dispatch(updateRelevantFilterThunk(!isActive));

  return (
    <Root className={props.className}>
      <Toggle checked={isActive} onCheck={toggle} />
      <span>{t("page.search.filter.onlyRelevant.title")}</span>
      <InfoCircle
        content={<div className={"scha__popper-tooltip__inner"}>{t("page.search.filter.onlyRelevant.infoPopup")}</div>}
      />
    </Root>
  );
};

const Root = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: ICON_MARGIN,
}));
